/* esm.sh - d3-transition@3.0.1/src/transition/text */
export * from "/*d3-transition@3.0.1/esnext/src/transition/text.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/text.mjs";
